<p-toast position="bottom-right" /> <router-outlet />
